import React from "react";

import {
  Contact,
  ContactValidation,
} from "../../../../application/domain/proc-management";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { ListInput } from "./list-input";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

type Props = Contact & {
  orgId: string;
  isServiceProviderAccount?: boolean;
  validationErrors?: ContactValidation;
} & PathProps &
  InputProps;

const ContactInput: React.FC<Props> = (props) => {
  const {
    name,
    tel,
    fax,
    email,
    onChange,
    basePath,
    disabled = false,
    shouldDisplayError,
    validationErrors,
  } = props;
  const usedIf = props.usedIf ?? [];
  const usedIfValidationErrors = validationErrors?.usedIf ?? [];
  return (
    <div>
      <div className="mb-2">
        <FormFieldLabel label="問い合わせ先名" bold={false} required />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "name"]}
          value={name}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.name}
          maxLength={getMaxLength("contactName")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="電話番号" bold={false} required />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "tel"]}
          value={tel}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.tel}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="Fax" bold={false} />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "fax"]}
          value={fax}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.fax}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="メールアドレス" bold={false} />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "email"]}
          value={email}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.email}
        />
      </div>

      <ListInput
        label="利用条件"
        boldLabel={false}
        mb={2}
        component={SimpleTextInput}
        componentProps={usedIf.map((value, i) => ({
          value,
          onChange,
          shouldDisplayError,
          errorMsg: usedIfValidationErrors[i],
        }))}
        basePath={[...basePath, "usedIf"]}
        onPush={() => {
          onChange([...basePath, "usedIf"], [...usedIf, ""]);
        }}
        onRemove={(i) => {
          onChange(
            [...basePath, "usedIf"],
            [...usedIf.slice(0, i), ...usedIf.slice(i + 1)],
          );
        }}
        disabled={disabled}
        notices={[
          "特定のケースでのみ問い合わせを受け付ける窓口がある場合、そのための条件を指定することができます。",
        ]}
      />
    </div>
  );
};

export default ContactInput;
